import { AdminTranslations } from '../types';

export const admin: AdminTranslations = {
  dashboard: {
    title: 'Panel de Administración Gándara',
    subtitle: 'Acceso Admin (Sesión temporal)',
    signOut: 'Cerrar sesión',
    renewalRequests: 'Solicitudes de Renovación',
    requestsCount: 'solicitud en total',
    requestsCountPlural: 'solicitudes en total',
    noRequests: 'No hay solicitudes de renovación',
    noRequestsHint: 'Las solicitudes aparecerán aquí cuando las familias completen el formulario de renovación',
    loading: 'Cargando renovaciones...',
    exportCsv: 'Exportar CSV',
  },
  filters: {
    placeholder: 'Buscar por nombre, email, teléfono o nombre de hijo/a...',
    dateFrom: 'Desde',
    dateTo: 'Hasta',
    paymentStatus: 'Estado de pago',
    all: 'Todos',
    paid: 'Pagado',
    unpaid: 'Pendiente',
    today: 'Hoy',
    thisWeek: 'Esta semana',
    thisMonth: 'Este mes',
    clearFilters: 'Limpiar filtros',
    search: 'Buscar',
  },
  table: {
    date: 'Fecha',
    parent: 'Padre/Madre',
    children: 'Hijos',
    pricing: 'Precio',
    status: 'Estado',
    notes: 'Notas',
    annual: 'Anual',
    monthly: 'Mensual',
  },
  payment: {
    title: 'Estado de Pago',
    paid: 'Pagado',
    unpaid: 'Pendiente',
    date: 'Fecha de pago',
    dateRequired: 'La fecha de pago es obligatoria al marcar como pagado',
    notes: 'Notas de pago',
    notesPlaceholder: 'Nº de transferencia, referencia, etc.',
    save: 'Guardar',
    saving: 'Guardando...',
    saved: 'Estado de pago actualizado',
    error: 'Error al actualizar el pago',
  },
  notes: {
    title: 'Notas del Admin',
    placeholder: 'Añadir una nota...',
    add: 'Añadir',
    adding: 'Añadiendo...',
    empty: 'Sin notas todavía',
    error: 'Error al añadir la nota',
  },
  details: {
    contactInfo: 'Información de Contacto',
    email: 'Email',
    phone: 'Teléfono',
    language: 'Idioma',
    children: 'Hijos/as',
    birthDate: 'Fecha de nacimiento',
    level: 'Nivel',
    childOrder: 'hijo/a',
    pricing: 'Detalles de Precios',
    matriculaTotal: 'Total Matrícula',
    annualTuition: 'Cuota Anual',
    earlyBirdDiscount: 'Descuento Early Bird',
    annualDiscount: 'Descuento Pago Anual',
    paymentType: 'Tipo de Pago',
    annualPayment: 'Anual',
    monthlyPayment: 'Mensual (10 meses)',
    services: 'Servicios Interesados',
    transport: 'Transporte',
    comedor: 'Comedor',
    aulaMadruga: 'Aula Madruga',
    noServices: 'Sin servicios adicionales seleccionados',
    comments: 'Comentarios',
  },
};
